import React from 'react'
import LivestreamPlayerComponent from '../../../components/academy/livestream/LivestreamPlayer'

const AcademyLiveStreamPlayer = () => {
  return (
    <div className='w-full'>
        <LivestreamPlayerComponent />
    </div>
  )
}

export default AcademyLiveStreamPlayer